import { createSelector } from "reselect"
import { pick } from "lodash"
import { getSelectedBase } from "modules/portfolio-root/selectors/base"
import { getIsActive } from "modules/portfolio-root/selectors/portfolios"

export const getContextBase = createSelector(
  [getSelectedBase, getIsActive],
  (selectedBase, isActive) => {
    if (isActive) {
      return pick(selectedBase, ["type", "id"])
    }

    return null
  },
)
